/**
 * useRequireAuth — Shows the login overlay when the user is not authenticated.
 *
 * Extracts the repeated "if not logged in, show login modal" pattern found in
 * CommunityPage, CommunitySsoLogin, and CommunityProfileSettingsPage.
 *
 * Returns { isLoggedIn } so callers can gate rendering on auth state.
 */

import { useEffect } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { getBoundActions } from '../../../actions/index'
import { TYPE_LOGIN } from '../../dialog/index'
import { isBrowser } from '../../../config/environment'
import { selectAuthUid } from '../identity/profile/redux/state-types'

interface UseRequireAuthReturn {
  isLoggedIn: boolean
}

export default function useRequireAuth (): UseRequireAuthReturn {
  const uid = useSelector(selectAuthUid)
  const dispatch = useDispatch()
  const { dialog: dialogActions } = getBoundActions(dispatch)

  const isLoggedIn = !!uid

  useEffect(() => {
    if (!isBrowser()) return
    if (!isLoggedIn) {
      dialogActions.setOverlayDialogVisible(TYPE_LOGIN)
      dialogActions.setDialogOptions(null, true)
      dialogActions.setOverlayCloseOnClick(false)
    }
  }, [isLoggedIn, dialogActions])

  return { isLoggedIn }
}
